import React from 'react';

import classNames from 'classnames';
import { useThemeContext } from '@infoods/lifebase-ui';

import classes from './TotalAmountChart.module.scss';
import { SegmentedBar } from './SegmentedBar/SegmentedBar';
import { SummaryDetails } from './SummaryDetails/SummaryDetails';
import { getPriceView } from '../../../../../shared/utils/stringUtils';
import { useTotalAmountChart } from './hooks/useTotalAmountChart';
import { RevenueGeneralFilterValues } from '../../DetailedRevenue.settings';
import { getFormattedDate } from '../../../../../shared/utils/dateUtils';
import { localDateTimeFormat } from '../../../../../shared/constants/apiDateFormat';

type TotalAmountChartProps = {
  entityId: number;
  generalFilters: RevenueGeneralFilterValues;
};

const TotalAmountChart = ({ entityId, generalFilters }: TotalAmountChartProps) => {
  const { palette } = useThemeContext();

  const { loadTime, totalAmount, totalAmountChartConfig } = useTotalAmountChart(
    entityId,
    generalFilters,
    palette,
  );

  return (
    <div>
      <div className={classes.titleBlock}>
        <h5 className={classes.title}>Total Amount</h5>
        <p className={classNames(classes.total, 'private-info')}>
          {getPriceView(totalAmount)}
        </p>
        <p className={classes.description}>
          Data is accurate on {getFormattedDate(loadTime, localDateTimeFormat)}
        </p>
      </div>
      <SegmentedBar totalAmount={totalAmount} config={totalAmountChartConfig} />
      <SummaryDetails config={totalAmountChartConfig} />
    </div>
  );
};

export { TotalAmountChart };
